import axios from '@/http/apiRequest';

//  获取伪静态模板
export const rewriteList = () => {
    return axios.request({
        method: "POST",
        url: '/api/vhost/config/rewrite/list',
    })
};

// 保存伪静态模板
export const  rewriteSave = (data) => {
    return axios.request({
        method: "POST",
        url: '/api/vhost/config/rewrite/save',
        data
    })
}

// 删除伪静态模板
export const  rewriteDelete = (code) => {
    return axios.request({
        method: "POST",
        url: `/api/vhost/config/rewrite/delete/${code}`,
    })
}

// 设置伪静态模板
export const  rewriteSet = (code) => {
    return axios.request({
        method: "POST",
        url: `/api/vhost/config/rewrite/set/${code}`,
    })
}

// 取消伪静态
export const  rewriteReset = () => {
    return axios.request({
        method: "POST",
        url: `/api/vhost/config/rewrite/reset`,
    })
}


// AI帮配
export const  locationConfig = (data) => {
    return axios.request({
        method: "POST",
        url: `/api/ai/suggestion/location/config`,
        data
    })
}

// 设置是否启用模版
export const  rewriteEnable = (data) => {
    return axios.request({
        method: "POST",
        url: `/api/vhost/setEnableTemplate`,
        params:data
    })
}
